// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
/**
 * Provides a method for generating preview thumbnails from html content.
 */
export const Api = {
    /**
     * Given some html content, generate a thumbnail image of the content. The thumbnail is returned as a byte array. This allows
     * the caller to handle the image in whatever way is most convenient. The thumbnail returned over html is a base64 encoded png
     * image. This can be injected into an image tag and displayed to the user.
     */
    GenerateThumbnail(fn, req) {
        return fn(`/messaging/html-thumbnail-generator/v1/thumbnails:generate`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
